import React, { Component } from 'react';
import CloudProcessingBox from '../CloudProcessingBox';
import intl from "react-intl-universal";


class CloudProcessing extends Component {
    state = {}
    render() {
        return (
            <React.Fragment>
                <div>
                    <h3 className='hTitleAccount'>Cloud Processing</h3>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Cloud Processing Packages:
                        <i alt={intl.get("Refresh_List")} title={intl.get("Refresh_List")} className={`fa fa-sync ${this.props.spinRefreshIcon ? "fa-spin" : ""}`} 
                        style={{fontSize:"24px",color: "rgb(2, 134, 187)", float:"right", position: "relative", cursor: "pointer"}} onClick={(event) => {
                            event.preventDefault();
                            this.props.changeSpinRefreshIcon()
                            this.props.refreshData();
                        }}></i>
                    </div>
                    {(this.props.iscloudProcessingPackagesLoading) ? (
                        <div align="center">
                            <div>Loading...</div>
                        </div>
                    ) : (this.props.cloudProcessingPackages.length == 0) ?
                        <div align="center">No data found</div> : (
                            <table
                                className={
                                    this.props.iscloudProcessingPackagesLoading
                                        ? "tableDisabled tdAlignMiddle"
                                        : "table tdAlignMiddle"
                                }
                            >
                                <thead>

                                </thead>
                                <tbody>
                                    {this.props.cloudProcessingPackages.map((row1, j) => {
                                        return (
                                            <tr key={j}>
                                                <td key={row1.packageId}>Package ID: <strong>{row1.packageId}</strong></td>
                                                <td style={{
                                                        visibility: row1.products.endpoint_name ? "visible" : "hidden"
                                                    }}>Endpoint:&nbsp;
                                                    <strong>
                                                        {row1.products.endpoint_name==undefined ? "loading..." : row1.products.endpoint_name ? row1.products.endpoint_name : ""}
                                                    </strong>
                                                </td>
                                                <td key={row1.products.ProductName} className="statusClass">
                                                    Status:                               <strong>
                                                        <span className={row1.packages.isActive &&
                                                            (new Date(row1.packages.expirationeDate) > new Date() ||
                                                                row1.packages.expirationeDate === "0001-01-01T00:00:00")
                                                            ? "spaceToHeadlines greenColor"
                                                            : "spaceToHeadlines redColor"}>
                                                            {row1.packages.isActive &&
                                                                (new Date(row1.packages.expirationeDate) > new Date() ||
                                                                    row1.packages.expirationeDate === "0001-01-01T00:00:00")
                                                                ? "Active"
                                                                : "Not Active"}
                                                        </span>
                                                    </strong>
                                                </td>
                                                <td>Expiration Date: <strong className={
                                                    new Date(row1.packages.expirationeDate) < new Date() &&
                                                        row1.packages.expirationeDate !== "0001-01-01T00:00:00"
                                                        ? "redColor"
                                                        : ""
                                                }>
                                                    {row1.GigaPixel
                                                        ? "-"
                                                        : new Date(row1.packages.expirationeDate).toDateString()}
                                                </strong></td>
                                                <td>
                                                    Available:&nbsp;
                                                    <strong className="">
                                                        {this.props.calcAvailable(row1)}
                                                    </strong>
                                                </td>
                                                <td>
                                                    Used:&nbsp;
                                                    <strong className="">
                                                        {this.props.calcUsed(row1)}
                                                    </strong>
                                                </td>
                                                <td id="createNewCloudProcessingButtonTdTd" className="createNewCloudProcessingButtonTd">
                                                    <button
                                                        id="createNewCloudProcessingButtonId"
                                                        className="LoaderButton btn-primary btn btn-default createNewCloudProcessingButton"
                                                        style={{
                                                            textTransform: "none",
                                                        }}
                                                        onClick={event => {
                                                            this.props.props.history.push("PMProjects/newPMProject?packageId=" + row1.packageId);
                                                        }}
                                                        disabled={row1.packages.isActive == false || new Date(row1.packages.expirationeDate) < new Date()}
                                                    >
                                                        New Project
                                                    </button>
                                                </td>
                                            </tr>

                                        )
                                    })}
                                </tbody>
                            </table>
                        )}
                </div>

                <div id="cloudProcessingProjectsDiv">
                    <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Cloud Processing Projects:</div>
                    {
                        this.props.isCloudProcessingDataLoading ? (
                            <div align="center">
                                <div>Loading...</div>
                            </div>
                        ) : (this.props.cloudProcessingData.length == 0) ?
                            (<div align="center">
                                <div>No project created yet</div>
                            </div>) :
                            this.props.cloudProcessingData.map((row, i) => {
                                return (
                                    <CloudProcessingBox key={i} cloudProcessingData={row}></CloudProcessingBox>
                                )
                            })
                    }
                </div>
            </React.Fragment>
        );
    }
}

export default CloudProcessing;